import { FIREBASE_CONFIG } from "@/shared/constants/ConfigConstants";
import firebase from "firebase/app";
import "firebase/firestore";

const app = firebase.initializeApp(FIREBASE_CONFIG);
const firebaseDB = firebase.firestore(app);

export { firebaseDB };
